import { ReactElement, useState } from 'react';
import debounce from 'lodash/debounce';
import { Collapse, Box } from '@chakra-ui/react';

import { useSearchTechsLazyQuery } from 'lib/generated/graphql';
import {
  AsyncSelect,
  SelectOption,
} from 'components/molecules/jobs/filters/asyncSelect';
import { useJobFilters } from 'lib/repositories/jobsShowcaseFilters';

import { MobileFilterCard } from '../card';

export interface TechnologiesProps {
  handleSearchJobs(): void;
}

export const Technologies = ({
  handleSearchJobs,
}: TechnologiesProps): ReactElement => {
  const { filters, setTechs } = useJobFilters();
  const [show, setShow] = useState(false);

  const [getTechs] = useSearchTechsLazyQuery();

  const resetFilter = () => {
    setTechs([]);
  };

  const loadTechOptions = debounce(
    (value: string, callBack: (options: SelectOption[]) => void) => {
      getTechs({ variables: { textSearch: value } }).then((response) =>
        callBack(
          response.data?.searchTechs.map((tech) => ({
            text: tech.name,
            value: tech.id,
          })) || []
        )
      );
    },
    500
  );

  return (
    <MobileFilterCard
      isActive={!!(filters.techs && filters.techs?.length > 0)}
      showTooltip={false}
      showResetFilter
      resetFilter={resetFilter}
      label='Habilidades'
      title='Habilidades'
      handleSearchJobs={handleSearchJobs}
    >
      <Collapse startingHeight={60} in={show}>
        <Box h='270'>
          <AsyncSelect
            isMulti
            label='Habilidades'
            loadOptions={loadTechOptions}
            name='order'
            onChange={(newValue) => setTechs(newValue as SelectOption[])}
            placeholder='Selecione as Habilidades'
            selectedOptionStyle='check'
            value={filters.techs}
            isClearable
            onMenuOpen={() => setShow(true)}
            onMenuClose={() => setShow(false)}
            defaultOptions
          />
        </Box>
      </Collapse>
    </MobileFilterCard>
  );
};
